import { observer } from 'mobx-react';
import * as React from 'react';
import { transl } from '../main/transl';

interface IEmptyTableRendererProps {
	page: string
	src: string
	isFilteredOut: boolean
}

@observer export class EmptyTableRenderer extends React.Component<IEmptyTableRendererProps> {
	render() {
		const {page, src, isFilteredOut} = this.props;
		const txt = isFilteredOut ? 'noDataAfterFilter' : page + '.noData';
		return <div style={{width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
			<div style={{textAlign: 'center', padding: 20}}>{transl(txt)}</div>
			{
				!src ? null :
					<img style={{width: 'auto', height: 'auto', maxWidth: '80%', maxHeight: '70%'}} src={src}/>
			}
		</div>;
	}
}
